// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__3p0Sb","navActive":"Navigation_navActive__RvJgG","link":"Navigation_link__DXZtF","active":"Navigation_active__qK2Hj"};